<template>
  <div>
    <div class="input-box-handler mt-8" v-validate="errors" v-has-value="legalRepresentative.nationality">
      <SelectField
        class="input-box mb-10"
        title='Nationality'
        :options="$store.state.countries"
        v-model="legalRepresentative.nationality"
        withAllOptions
        required
        valueOnlyFromOptions
      />
      <div class="validation-output text-left mt-2">
        <ErrorHandler class="error" :id="`V220_${index}`">
          Select the nationality of the policyholder.
        </ErrorHandler>

        <ErrorHandler class="error" :id="`V301_${index}`">
          Select the nationality of the policyholder.
        </ErrorHandler>
      </div>
    </div>

    <LegalRepresentativeIdentityVerification
      v-if="isIdentityVerificationRequired"
      :person-index="index"
      :legal-representative="legalRepresentative"
      :model="model"
      :errors="errors"
      :is-first-legal-representative="false"
    />
  </div>
</template>
<script>
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';
import SelectField from '@/components/SelectField/SelectField.vue';
import LegalRepresentativeIdentityVerification from '@/pagesComponents/LegalRepresentativeIdentityVerification.vue';
import enums from '@/mixins/enums';

export default {
  components: {
    LegalRepresentativeIdentityVerification,
    SelectField,
    ErrorHandler,
  },
  mixins: [enums],
  props: {
    legalRepresentative: {
      type: Object,
      required: true,
    },
    insuredPerson: {
      type: Object,
      required: true,
    },
    errors: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    model: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isIdentityVerificationRequired() {
      return this.insuredPerson.insuredPersonType === this.enums.InsuredPersonTypeEnum.BIRTH_OF_CHILD
        && this.insuredPerson.firstLegalRepresentative.relationship === this.enums.RelationshipEnum.PARENT;
    },
  },
};
</script>
